import React from 'react';
import { motion } from 'framer-motion';

const EmpowerSection = ({ data }) => {
    // Agar data nahi milta to component render mat karo
    if (!data) return null;

    return (
        <section className="w-full overflow-hidden bg-[#F0F0F0]">
            <div className="max-w-[1440px] w-full mx-auto">
                <div className=" flex flex-col overflow-hidden md:flex-row">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="w-full md:w-full flex flex-col justify-center p-[30px] md:p-[80px]"
                    >
                        {/* Dynamic Heading */}
                        <h2 className="text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.3] mb-[35px] font-sora">
                            {data.heading}
                        </h2>

                        {/* Dynamic Paragraphs (Array map) */}
                        {data.descriptions.map((desc, index) => (
                            <p key={index} className="text-[#49577A] text-[14px] md:text-[16px] leading-[1.8] font-graphik font-[500] max-w-[600px] mb-4 last:mb-0">
                                {desc}
                            </p>
                        ))}

                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="w-full md:w-full max-w-[656px] min-h-[400px] lg:min-h-[507px] relative"
                    >
                        {/* Dynamic Image */}
                        <img
                            src={data.image}
                            alt={data.heading}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default EmpowerSection;